import { useNavigate } from 'react-router';
import { routeHelper } from 'src/app/helpers';
import { InterestPropertiesType } from 'src/app/pages/InterestsPage/interests-page.config';
import { InterestClassType, InterestComponents, InterestsTypes } from 'src/enums/interests.enum';
import { RoutesType } from 'src/types/routes.type';

// This custom hook is used to handle route for selected interest
const useInterestTableClick = () => {
  const navigate = useNavigate();

  /*
  When clicked to interest navigate to the given route parameters.
  Add interest data and component type as state to navigated url.
  For extra state, state parameter should be provided.
  */
  const onInterestClick = (
    record: {
      id: string;
      name?: string;
      type: InterestsTypes;
      classType: InterestClassType;
      properties?: InterestPropertiesType | null;
    }[],
    componentType: InterestComponents,
    route: RoutesType = '/Interests',
    state?: any,
    tab?: string,
  ) => {
    routeHelper.handleRoute(
      navigate,
      route,
      { ...(tab && { tab }) },
      {
        interests: record,
        componentType,
        ...state,
      },
    );
  };

  return { onInterestClick };
};

export default useInterestTableClick;
